import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useDomain } from '@useDomain';

import './DefaultNavbar.css'

function DefaultNavbar() {
 const { slug } = useDomain(); // ✅ Just need slug here
 const [isOpen, setIsOpen] = useState(false);
 const [isClosing, setIsClosing] = useState(false);
 const { organization: org } = useDomain();

 const fallbackSlug = window.location.pathname.split("/")[1];
 const basePath = slug ? `/${slug}` : `/${fallbackSlug}`;

 const closeMenu = () => {
  setIsClosing(true);
  setTimeout(() => {
   setIsOpen(false);
   setIsClosing(false);
  }, 1);
 };

 const toggleMenu = () => {
  if (isOpen) {
   closeMenu();
  } else {
   setIsOpen(true);
  }
 };

 return (
  <nav className="navbar_container light-theme">
   <div className="navbar_left">
    <div className="navbar_left">
     <NavLink to={basePath} className="navbar_logo_link" onClick={closeMenu}>
      <img src={org.logo_url} alt="Logo Here" className="navbar_logo_image" />
     </NavLink>
    </div>

   </div>

   <div className="navbar_right">
    <button className="navbar_hamburger" onClick={toggleMenu}>
     {isOpen ? <FaTimes /> : <FaBars />}
    </button>

    <ul className={`navbar_list ${isOpen ? 'open' : ''} ${isClosing ? 'closing' : ''}`}>
     <li>
      <NavLink to={`${basePath}`} onClick={closeMenu}>HOME</NavLink>
     </li>
     {/* <li>
      <NavLink to={`${basePath}/teamList`} onClick={closeMenu}>TEAMS</NavLink>
     </li> */}
     <li>
      <NavLink to={`${basePath}/players`} onClick={closeMenu}>PLAYERS</NavLink>
     </li>
     <li>
      <NavLink to={`${basePath}/games`} onClick={closeMenu}>GAMES</NavLink>
     </li>
    </ul>
   </div>
  </nav>
 );
}

export default DefaultNavbar;
